export class Links {
  title:         string | null = null;
  subTitle:      string | null = null;
  info:          string | null = null;
  rota:          string | null = null;
  tipo:          string | null = null;
}
